export default __webpack_public_path__ + "static/media/instagram.baa5072f.svg";